import React from 'react';
import { CssBaseline, Paper, ThemeProvider, Typography, Button } from '@material-ui/core';
import useStyles from '../styles/CustomStyle';
import "../styles/MuiCustom.css"
import NavBar from './NavBar';
import VehiclInformation from './VehicleInformation';
import theme from '../theme/CustomTheme';
import ProgressBar from './ProgressBar';
import axios from 'axios';
import Copyright from './Copyright'


function getStepContent(step, stepContent, handleChange, handleNext, handleBack, handleSubmit, brands, setBrands, models, setModels, error, setError, progressAlert, setProgressAlert) {
    switch (step) {
        case 0:
            return <VehiclInformation stepContent={stepContent} handleChange={handleChange} handleNext={handleNext} handleBack={handleBack} brands={brands} setBrands={setBrands} models={models} setModels={setModels} error={error} setError={setError} />;
        case 1:
            return <ProgressBar handleSubmit={handleSubmit} alert={progressAlert} handleBack={handleBack} setAlert={setProgressAlert} />;
        default:
            throw new Error('Unknown step');
    }
}

export default function NewVehicleAddition() {
    const classes = useStyles();
    let imageObj = {
        file: "",
        fileUrl: "",
        fileData: {}
    }
    const [activeStep, setActiveStep] = React.useState(0);
    const [brands, setBrands] = React.useState([])
    const [models, setModels] = React.useState([])

    const [progressAlert, setProgressAlert] = React.useState({
        show: false,
        type: "",
        title: "",
        text: "",
    })
    const [stepContent, setStepContent] = React.useState({
        car_type: "",
        vehicle_identification_no: "",
        vehicle_registration_year: "",
        max_passengers: "",
        vehicle_year: "",
        vehicle_make: "",
        vehicle_model: "",
        license_plate_district: "",
        license_plate_series: "",
        driving_registration_front: imageObj,
        license_plate_no: "",
        tax_token: imageObj,
        insurance: imageObj,
        fitness: imageObj,
        license_expiry_date: null
    })
    const [error, setError] = React.useState({
        car_type: false,
        vehicle_identification_no: false,
        vehicle_year: false,
        vehicle_registration_year: false,
        vehicle_make: false,
        vehicle_model: false,
        license_plate_no: {
            isEmpty: false,
            invalid: false
        },
        license_plate_district: false,
        license_plate_series: false,
        license_expiry_date: false,
    })
    const handleChange = (event, flag) => {
        if (flag === "license_plate_no" || flag === "license_expiry_date") {
            setStepContent({
                ...stepContent,
                [flag]: event
            });
        } else if (flag === "driving_registration_front" || flag === "tax_token" || flag === "insurance" || flag === "fitness") {
            setStepContent({
                ...stepContent,
                [flag]: {
                    file: event[event.length - 1]
                },
            });
        } else if (event.target.name === "car_type") {
            if (event.target.value === 0 || event.target.value === 10 || event.target.value === 11 || event.target.value === 12 || event.target.value === 13 || event.target.value === 14 || event.target.value === 15) {
                setStepContent({
                    ...stepContent,
                    car_type: event.target.value,
                    vehicle_make: "",
                    vehicle_model: "",
                    max_passengers: 4
                });
            } else if (event.target.value === 3 || event.target.value === 4) {
                setStepContent({
                    ...stepContent,
                    car_type: event.target.value,
                    vehicle_make: "",
                    vehicle_model: "",
                    max_passengers: 1
                });
            } else if (event.target.value === 5 || event.target.value === 9) {
                setStepContent({
                    ...stepContent,
                    car_type: event.target.value,
                    vehicle_make: "",
                    vehicle_model: "",
                    max_passengers: 3
                });
            }

        } else if (event.target.name === "vehicle_make") {
            setStepContent({
                ...stepContent,
                vehicle_make: event.target.value,
                vehicle_model: ""
            });
        }
        else {
            setStepContent({
                ...stepContent,
                [event.target.name]: event.target.value
            });
        }
    }
    const handleNext = (e) => {
        e.preventDefault();
        if (stepContent.car_type === "") {
            setError({
                ...error,
                car_type: true
            });
        } else if (!stepContent.vehicle_identification_no) {
            setError({
                ...error,
                vehicle_identification_no: true
            });
        } else if (!stepContent.vehicle_registration_year) {
            setError({
                ...error,
                vehicle_registration_year: true
            })
        } else if (!stepContent.vehicle_year) {
            setError({
                ...error,
                vehicle_year: true
            });
        } else if (!stepContent.vehicle_make) {
            setError({
                ...error,
                vehicle_make: true
            });
        } else if (!stepContent.vehicle_model) {
            setError({
                ...error,
                vehicle_model: true
            });
        } else if (!stepContent.license_plate_district) {
            setError({
                ...error,
                license_plate_district: true
            });
        } else if (!stepContent.license_plate_series) {
            setError({
                ...error,
                license_plate_series: true
            });
        } else if (!stepContent.license_plate_no) {
            setError({
                ...error,
                license_plate_no: {
                    isEmpty: true
                }
            });
        } else if (!stepContent.driving_registration_front.file) {
            alert("Vehicle registration photo not found")
        }
        else {
            setActiveStep(activeStep + 1);
        }
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const handleSubmit = () => {
        let formData = new FormData();
        let license_plate;
        if (stepContent.license_plate_district === "Dhaka" || stepContent.license_plate_district === "Chittagong") {
            license_plate = stepContent.license_plate_district + " Metro-" + stepContent.license_plate_series + " " + stepContent.license_plate_no
        } else {
            license_plate = stepContent.license_plate_district + " " + stepContent.license_plate_series + " " + stepContent.license_plate_no
        }
        formData.append("nameCtrl", JSON.parse(localStorage.getItem('user_name')))
        formData.append("user_id", JSON.parse(localStorage.getItem('user_id')))
        formData.append("admin_id", JSON.parse(localStorage.getItem('admin_id')))
        formData.append("phone_no", JSON.parse(localStorage.getItem('phone_no')))
        formData.append("city", JSON.parse(localStorage.getItem('present_district')))
        formData.append("reg_address", JSON.parse(localStorage.getItem('present_post_office')))
        formData.append("car_type", stepContent.car_type)
        formData.append("vehicle_identification_no", stepContent.vehicle_identification_no)
        formData.append("vehicle_registration_year", stepContent.vehicle_registration_year)
        formData.append("max_passengers", stepContent.max_passengers)
        formData.append("vehicle_year", stepContent.vehicle_year)
        formData.append("vehicle_make", stepContent.vehicle_make)
        formData.append("vehicle_model", stepContent.vehicle_model)
        formData.append("vehicle_license_plate", license_plate)
        formData.append("licenese_expiry_date", stepContent.license_expiry_date)
        formData.append("driving_registration_front", stepContent.driving_registration_front.file)
        formData.append("tax_token", stepContent.tax_token.file)
        formData.append("insurance", stepContent.insurance.file)
        formData.append("fitness", stepContent.fitness.file)
        axios.post(process.env.REACT_APP_REG_API_BASE + '/add_vehicle_from_reg_portal', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': JSON.parse(localStorage.getItem('token'))
            }
        }).then(res => {
            if (res.data.body.status === 201) {
                setProgressAlert({
                    show: true,
                    type: "error",
                    title: res.data.body.message
                })

            } else if (res.data.body.status === 200) {
                setProgressAlert({
                    show: true,
                    type: "success",
                    title: res.data.body.message,
                    text: "Pending for approval"
                })
            }
        }).catch(err => {
            setProgressAlert({
                show: true,
                type: "error",
                title: "Something went wrong!",
                text: "Please check your internet connection"
            })
        })
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <NavBar showMenu={true} title="Add Vehicle" />
            <main className={`${classes.layout} layout`} >
                <Paper className={classes.paper} style={{ marginTop: 90 }} elevation={4}>
                    {
                        activeStep === 0 ?
                            <Typography variant="h4" gutterBottom className="title" style={{ textAlign: "center", padding: "10px 0 20px 0" }}>
                                Vehicle Information
                            </Typography> : null
                    }
                    <ThemeProvider theme={theme}>
                        {getStepContent(activeStep, stepContent, handleChange, handleNext, handleBack, handleSubmit, brands, setBrands, models, setModels, error, setError, progressAlert, setProgressAlert)}
                        {
                            activeStep === 0 ?
                                <div className={classes.buttons}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        type="submit"
                                        className={classes.button}
                                    >
                                        Submit
                                    </Button>
                                </div> : ""
                        }

                    </ThemeProvider>
                </Paper>
                <Copyright />
            </main>
        </React.Fragment >
    );
}